import React from "react";
import StandardInstruction from "../StandardInstruction";
import ExpandableYouTubeEmbed from "../ExpandableYouTubeEmbed";

function PathBuilderInstructionsSeedkeeper({ t, options }) {
  const show = options.backupSeedToSeedkeeper || options.importKeyFromSeedkeeper;
  if (!show) return null;

  return (
    <div className="instruction-category-group">
      <h3 className="instruction-category-header">{t("pathBuilder.categories.seedsignerSeedkeeper")}</h3>
      {options.backupSeedToSeedkeeper && (
        <StandardInstruction
          title={t("pathBuilder.instructionTitles.backupSeedToSeedkeeper")}
          icon="💾"
          intro={
            <>
              <p style={{ marginBottom: "12px", padding: "8px 10px", background: "rgba(102, 126, 234, 0.1)", borderLeft: "3px solid rgba(102, 126, 234, 0.5)", borderRadius: "4px", color: "#b0b0b0", fontSize: "0.85em", lineHeight: "1.6" }}>
                {t("pathBuilder.instructionContent.backupSeedToSeedkeeperNote")}
              </p>
              <ExpandableYouTubeEmbed
                videoId="https://youtu.be/X-vmFHU9Ec8?si=D79-BgsMyk56g9v_"
                title={t("pathBuilder.instructionContent.backupSeedToSeedkeeperVideoLink")}
              />
            </>
          }
          steps={{
            items: [
              t("pathBuilder.instructionContent.backupSeedToSeedkeeperStep1"),
              t("pathBuilder.instructionContent.backupSeedToSeedkeeperStep2"),
              t("pathBuilder.instructionContent.backupSeedToSeedkeeperStep3"),
              t("pathBuilder.instructionContent.backupSeedToSeedkeeperStep4"),
              t("pathBuilder.instructionContent.backupSeedToSeedkeeperStep5"),
              t("pathBuilder.instructionContent.backupSeedToSeedkeeperStep6"),
              t("pathBuilder.instructionContent.backupSeedToSeedkeeperStep7"),
            ],
          }}
        />
      )}
      {options.importKeyFromSeedkeeper && (
        <StandardInstruction
          title={t("pathBuilder.instructionTitles.importKeyFromSeedkeeper")}
          icon="📥"
          intro={
            <ExpandableYouTubeEmbed
              videoId="https://youtu.be/ms0Iq_IyaoE?si=_8yxv_9aqAJf4ZWR"
              title={t("pathBuilder.instructionContent.importKeyFromSeedkeeperVideoLink")}
            />
          }
          steps={{
            items: [
              t("pathBuilder.instructionContent.importKeyFromSeedkeeperStep1"),
              t("pathBuilder.instructionContent.importKeyFromSeedkeeperStep2"),
              t("pathBuilder.instructionContent.importKeyFromSeedkeeperStep3"),
              t("pathBuilder.instructionContent.importKeyFromSeedkeeperStep4"),
              t("pathBuilder.instructionContent.importKeyFromSeedkeeperStep5"),
              t("pathBuilder.instructionContent.importKeyFromSeedkeeperStep6"),
              t("pathBuilder.instructionContent.importKeyFromSeedkeeperStep7"),
            ],
          }}
        />
      )}
    </div>
  );
}

export default PathBuilderInstructionsSeedkeeper;
